import Artsy from "@/assets/social-icons/artsy.svg";
import Facebook from "@/assets/social-icons/facebook.svg";
import Flickr from "@/assets/social-icons/flickr.svg";
import Instagram from "@/assets/social-icons/instagram.svg";
import LinkedIn from "@/assets/social-icons/linkedin.svg";
import Rss from "@/assets/social-icons/rss.svg";
import Streamly from "@/assets/social-icons/streamly.svg";
import Threads from "@/assets/social-icons/threads.svg";
import TikTok from "@/assets/social-icons/tiktok.svg";
import Twitter from "@/assets/social-icons/twitter.svg";
import WhatsApp from "@/assets/social-icons/whatsapp.svg";
import YouTube from "@/assets/social-icons/youtube.svg";
import { SocialIconType } from "@/constants/media";

export function getSocialIconByType(iconType: SocialIconType) {
  switch (iconType) {
    case SocialIconType.LinkedIn:
      return LinkedIn;
    case SocialIconType.Twitter:
      return Twitter;
    case SocialIconType.Instagram:
      return Instagram;
    case SocialIconType.Facebook:
      return Facebook;
    case SocialIconType.YouTube:
      return YouTube;
    case SocialIconType.Blog:
      return Rss;
    case SocialIconType.Artsy:
      return Artsy;
    case SocialIconType.Flickr:
      return Flickr;
    case SocialIconType.TikTok:
      return TikTok;
    case SocialIconType.Threads:
      return Threads;
    case SocialIconType.Streamly:
      return Streamly;
    case SocialIconType.WhatsApp:
      return WhatsApp;
  }
}
